import { render, staticRenderFns } from "./PrHoldBottom.vue?vue&type=template&id=41fa462e&"
import script from "./PrHoldBottom.vue?vue&type=script&lang=js&"
export * from "./PrHoldBottom.vue?vue&type=script&lang=js&"
import style0 from "./PrHoldBottom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports